const firebaseConfig = {
  apiKey: "AIzaSyATtaK4Yqm6yh3ixsVT_h-jF5Td5SEVztk",
  authDomain: "assignment-9-2b49a.firebaseapp.com",
  projectId: "assignment-9-2b49a",
  storageBucket: "assignment-9-2b49a.appspot.com",
  messagingSenderId: "824497318783",
  appId: "1:824497318783:web:2e2147a874c843ea23484a"
};

  export default firebaseConfig;